module.exports = __webpack_public_path__ + "img/beri.a0aaddb9.svg";